export default __webpack_public_path__ + "static/media/NextArrow.2b70eeaf.svg";